import img1 from '../../assets/images/review-1.jpg';
import img2 from '../../assets/images/review-2.jpg';
import img3 from '../../assets/images/review-3.jpg';

const reviews = [
    {
        name: 'Jessica Cameron',
        comment: 'I had a really great with my family in Switzerland. Wanderlust is just amazing. Everything went so smoothly.',
        image: img1
    },
    {
        name: 'Jonas Smith',
        comment: 'The service is excellent. Wonderful experience.',
        image: img2
    },
    {
        name: 'Lily Aldrin',
        comment: 'I was amazed by the service provided by Wanderlust. Highly recommended!',
        image: img3
    }
];

export default reviews;